import { $gt as __gt, createQueryOperator } from "../../_predicates";
const $gt = createQueryOperator(__gt);
export {
  $gt
};
